import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthAPI } from '../api';
import bannerSrc from "../assets/repleeno_login.jpeg";

export default function Login() {
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr('');
        setLoading(true);
        try {
            const res = await AuthAPI.login(form.email.trim(), form.password);
            if (!res || !res.token) {
                setErr(res?.error || 'Login failed'); setLoading(false); return;
            }
            // persist token + user
            localStorage.setItem('token', res.token);
            if (res.user) localStorage.setItem('user', JSON.stringify(res.user));
            navigate('/', { replace: true });
        } catch (e2) {
            setErr(e2?.error || 'Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
            <form onSubmit={onSubmit} className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
                <div className="mb-4">
                    <img
                        src={bannerSrc}
                        alt="HarethOptics Merchant"
                        loading="lazy"
                        className="w-full h-24 md:h-40 object-contain bg-white"
                    />
                    <h1 className="mt-2 text-xl font-semibold">HarethOptics Admin</h1>
                    <p className="text-sm text-slate-600">Sign in to your admin account</p>
                </div>

                {err && <div className="mb-3 rounded-lg border border-red-200 bg-red-50 p-2 text-sm text-red-700">{err}</div>}

                <label className="block text-sm text-slate-700">
                    Email
                    <input
                        type="email"
                        className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                    />
                </label>

                <label className="mt-3 block text-sm text-slate-700">
                    Password
                    <input
                        type="password"
                        className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        required
                    />
                </label>

                <button
                    type="submit"
                    disabled={loading}
                    className="mt-4 w-full rounded-xl bg-emerald-600 px-3 py-2 text-white hover:bg-emerald-700 disabled:opacity-50"
                >
                    {loading ? 'Signing in…' : 'Sign in'}
                </button>
            </form>
        </div>
    );
}
